<template>
  <div class="exercises-list">
    <div class="header">
      <div class="button-wrapper">
        <ExerciseIcon
          stroke-width="3"
          stroke="#757575"
          class="exercise__icon"
        />
      </div>
      <div class="title">
        Exercises associated with this lesson
      </div>
    </div>
    <div class="exercise-wrapper">
      <div
        :class="[
          'exercise-row',
          !hasAccess(exercise) && 'exercise-row__disabled',
        ]"
        v-for="(exercise, index) in exercises"
        :key="`${exercise.id}${index}`"
        @click="openExercise(exercise)"
      >
        <div class="exercise-name">
          <TerminalIcon class="terminal-icon" />{{ twoDigitsIndex(index + 1) }}.
          {{ exercise.name }}
        </div>
        <CheckIcon
          class="status-icon"
          v-tooltip="{
            content: exercise.user_status,
            placement: 'right-center',
          }"
          :fill="hasCompleted(exercise.user_status)"
        />
      </div>
    </div>
    <div class="exercise__modal-wrapper">
      <ExerciseModal
        v-if="isModalShown"
        :exercise="currentExercise"
        :exercisesList="exercises"
        @closeModal="closeModal"
        @previousExercise="previousExercise()"
        @nextExercise="nextExercise()"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { isFreeContent } from '@/helpers'
import ExerciseIcon from '@/assets/icons/course/exercise/exercise-icon.svg'
import TerminalIcon from '@/assets/icons/course/exercise/terminal-icon.svg'
import CheckIcon from '@/assets/icons/course/exercise/check-circle.svg'
import ExerciseModal from '@/components/modals/exercise-modal/ExerciseModal.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'ExercisesList',
  components: {
    ExerciseIcon: { ...ExerciseIcon, name: 'ExerciseIcon' },
    TerminalIcon: { ...TerminalIcon, name: 'TerminalIcon' },
    CheckIcon: { ...CheckIcon, name: 'CheckIcon' },
    ExerciseModal,
  },
  data() {
    return {
      isModalShown: false,
      isLoading: true,
    }
  },
  props: {
    exercises: {
      type: Array,
      required: true,
    },
    isUser: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState({
      currentExercise: state => state.exercises.currentExercise,
    }),
  },
  methods: {
    async openExercise(exercise) {
      this.$store.dispatch('exercises/setCurrentExercise', exercise)
      this.isModalShown = true
    },
    twoDigitsIndex(index) {
      return index < 10 ? `0${index}` : index
    },
    hasCompleted(status) {
      if (status === CONSTANTS.CONTENT_USER_STATUS.FINISHED) {
        return '#00DEA0'
      }
      return '#727276'
    },
    closeModal() {
      this.isModalShown = false
      this.$store.dispatch('exercises/clearExerciseStore')
    },
    previousExercise() {
      const index = this.exercises.indexOf(this.currentExercise)
      if (index > 0) {
        this.openExercise(this.exercises[index - 1])
      }
    },
    nextExercise() {
      const index = this.exercises.indexOf(this.currentExercise)
      if (index < this.exercises.length - 1) {
        this.openExercise(this.exercises[index + 1])
      }
    },
    hasAccess(content) {
      if (this.isUser) return true
      return isFreeContent(content)
    },
  },
}
</script>

<style lang="scss" scoped>
.exercises-list {
  padding-top: 13px;
  padding-left: 0px;
  color: var(--white);
  font-size: 16px;
  font-family: var(--font-medium);
  .header {
    display: flex;
    align-items: center;
    .title {
      margin-left: 15px;
    }
    .button-wrapper {
      height: 62px;
      width: 62px;
      background: #222222;
      padding: 10px;
      .exercise__icon {
        background: #222222;
      }
    }
  }
  .exercise-wrapper {
    padding-top: 20px;
    padding-left: 80px;
    padding-bottom: 50px;
    .exercise-row {
      max-width: 90%;
      padding: 15px 0;
      border-bottom: 1px solid rgb(29, 29, 29);
      border-top: 1px solid rgb(29, 29, 29);
      transition: all 0.5s ease;
      display: flex;
      cursor: pointer;
      .terminal-icon {
        margin-right: 12px;
      }
      .status-icon {
        margin-left: auto;
      }
      &__disabled {
        pointer-events: none;
        opacity: 0.4;
      }
    }
    .exercise-row:hover {
      background: black;
      padding: 15px 10px;
    }
  }
}
</style>
